import { useEffect, useMemo, useCallback, useState } from "react";
import { RMtableDetailView } from "../../../redux/slices/rmSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import CustomCard from "../../../components/CustomCard/CustomCard";
import CustomTable from "../../../components/CustomTable/CustomTable";
import CustomModal from "../../../components/CustomModal/CustomModal";
import useSearchableTable from "../../../hooks/useSearchableTable";
import { getRmDetailColumns } from "./Components/getRmDetailColumns";
import { Flex, Input, Typography } from "antd";
import BackButton from "../../../components/CustomButton/BackButton";
import { TITLE_TXT, MODAL_WIDTHS } from "../../../constants/constants";
import ReassignRmForm from "./Components/ReassignRmForm";

const { Text } = Typography;

const RmDetails = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { rm } = location.state || {};
    const { rmdetailData, loading } = useSelector((state) => state?.rm);
    const [modalState, setModalState] = useState({
        isOpen: false,
        reassignUser: null,
    });

    useEffect(() => {
        dispatch(RMtableDetailView(rm?.userId));
    }, [dispatch, rm?.userId]);

    const { searchText, setSearchText, filteredData } = useSearchableTable(rmdetailData);

    const handleReassignRm = useCallback(
        (user) =>
            setModalState({
                isOpen: true,
                reassignUser: user
            }),
        []
    );

    const columns = useMemo(
        () =>
            getRmDetailColumns({
                onReassign: handleReassignRm,
            }),
        [handleReassignRm]
    );

    return (
        <CustomCard className="rm-details-card">
            <Flex
                align="center"
                justify="space-between"
                wrap
                style={{ padding: "20px 30px" }}
            >
                <BackButton />
                <Input
                    placeholder="Search"
                    allowClear
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 250 }}
                />
            </Flex>
            <Flex
                align="center"
                justify="space-between"
                className="rm-details-container"
            >
                <Text>
                    RM Name: <Text strong>{rm?.userName}</Text>
                </Text>
                <Text>
                    RM ID: <Text strong>{rm?.userId}</Text>
                </Text>
            </Flex>
            <CustomTable
                rowKey="userId"
                columns={columns}
                dataSource={filteredData}
                loading={loading}
            />
            {modalState.isOpen && (
                <CustomModal
                    title={TITLE_TXT.RE_ASSIGN_RM}
                    open={modalState.isOpen}
                    centered
                    width={MODAL_WIDTHS}
                    content={
                        <ReassignRmForm
                            rm={rm}
                            reassignUser={modalState.reassignUser}
                            onClose={() =>
                                setModalState({
                                    isOpen: false,
                                })
                            }
                        />
                    }
                />
            )}
        </CustomCard>
    );
};

export default RmDetails;
